import { useGetToDoList } from "../../queries/dashboard";
import Loading from "./Loading";
import Section from "./Section";

const ToDo = () => {

    const { data: todoList, isPending: isTodoDataPending } = useGetToDoList();

    const items = [
        {
            key: 'pendingChallengeSubmissions',
            sentence: (n) => `pending challenge submission${n === 1 ? '' : 's'} need review.`,
        },
        {
            key: 'pendingEventSubmissions',
            sentence: (n) => `pending event submission${n === 1 ? '' : 's'} need review.`,
        },
        {
            key: 'pendingProposedChallenges',
            sentence: (n) => `proposed challenge${n === 1 ? '' : 's'} awaiting approval.`,
        },
        {
            key: 'pendingBlogSubmissions',
            sentence: (n) => `pending blog submission${n === 1 ? '' : 's'} need review.`,
        },
        {
            key: 'activeUserIssues',
            sentence: (n) => `active user issue${n === 1 ? '' : 's'} require attention.`,
        },
        {
            key: 'pendingPartnerCreateCampaignRequests',
            sentence: (n) => `partner request${n === 1 ? '' : 's'} to create campaign pending.`,
        },
        {
            key: 'pendingPartnerModificationCampaignRequests',
            sentence: (n) => `partner campaign modification request${n === 1 ? '' : 's'} pending.`,
        },
        {
            key: 'pendingPartnerSupportTickets',
            sentence: (n) => `partner support ticket${n === 1 ? '' : 's'} pending.`,
        },
    ];

    return (
        <Section
            isLoading={isTodoDataPending}
            title={"To-Do"}
            innerPadding={0}
            theme="yellow"
        >
            <div className="bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] p-4 py-2 overflow-y-auto max-h-52">
                <div className="flex flex-col gap-3">
                    {items.map(item => {
                        const n = todoList?.[item.key] ?? 0;
                        return (
                            <div key={item.key} className="flex items-start gap-3">
                                <div className="text-[#886701] font-bold">{n}</div>
                                <div className="text-base text-gray-700">{item.sentence(n)}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Section>
    );
}

export default ToDo;